import { render, staticRenderFns } from "./UserLink.vue?vue&type=template&id=be1d1c5a&scoped=true"
import script from "./UserLink.vue?vue&type=script&lang=js"
export * from "./UserLink.vue?vue&type=script&lang=js"
import style0 from "./UserLink.vue?vue&type=style&index=0&id=be1d1c5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be1d1c5a",
  null
  
)

export default component.exports